export default __webpack_public_path__ + "media/images/gift_fund/bank_transfer-0923845bc8fdc15dc6cea541e1b4e1b1.png";